import {Column} from 'react-table'
import {RegisterResponse, transformedRecord} from './api'
import {Link, useNavigate} from 'react-router-dom'
import {KTIcon, formatNumber} from '../../../../_metronic/helpers'
import {CardsWidget7} from '../../../../_metronic/partials/widgets'
export const getSalesAndPurchaseColumns = (
  activeTab: string,
  debouncedFrom: string,
  debouncedTo: string,
  // view: string,
  totalDebit: number,
  totalCredit: number,
  currency: string
): ReadonlyArray<Column<transformedRecord>> => [
  {
    Header: () => <th className='min-w-100px col-lg-1'>Date</th>,
    accessor: 'voucherDate',
    Cell: ({...props}) => (
      <div className='d-flex justify-content-center'>{props.data[props.row.index].voucherDate}</div>
    ),
  },
  {
    Header: () => <th className='min-w-100px col-lg-1'>Particulars</th>,
    accessor: 'particulars',
    Cell: ({...props}) => (
      <div className='d-flex justify-content-center'>
        <Link
          to={`/transactions/trial-balance/ledger?ledgerId=${
            props.data[props.row.index].ledgerId
          }&from=${debouncedFrom}&to=${debouncedTo}`}
          style={{
            color: '#343541',
          }}
          className='text-hover-primary'
        >
          {props.data[props.row.index].particulars}
        </Link>
      </div>
    ),
  },
  {
    Header: () => <th className='col-lg-1'>Voucher Type</th>,
    accessor: 'voucherType',
    Cell: ({...props}) => (
      <div className='d-flex justify-content-center'>{props.data[props.row.index].voucherType}</div>
    ),
  },
  {
    Header: () => <th className='col-lg-1'>Voucher Number</th>,
    accessor: 'voucherNumber',
    Cell: ({...props}) => (
      <div className='d-flex justify-content-center'>
        {props.data[props.row.index].voucherNumber}
      </div>
    ),
  },
  {
    Header: () => <th className='px-3 min-w-100px col-lg-1'>Debit</th>,
    accessor: 'debit',
    Cell: ({...props}) => (
      <div className='px-3 d-flex justify-content-end'>
        {/* {currency} */}
        {formatNumber(props.data[props.row.index].debit || 0)}
      </div>
    ),
    Footer: () => (
      <CardsWidget7
        className='border border-dashed border-gray-300 align-items-end'
        stats={`
        ${formatNumber(totalDebit)}`}
        description='Total Debits'
      />
    ),
  },
  {
    Header: () => <th className='px-3 min-w-100px col-lg-1'>Credit</th>,
    accessor: 'credit',
    Cell: ({...props}) => {
      // // console.log(props)
      return (
        <div className='px-3 d-flex justify-content-end'>
          {/* {currency}  */}
          {formatNumber(props.data[props.row.index].credit || 0)}
        </div>
      )
    },
    Footer: () => (
      <CardsWidget7
        className='border border-dashed border-gray-300 align-items-end'
        stats={`${formatNumber(totalCredit)}`}
        description='Total Credits'
      />
    ),
  },
]
